<template>
    <div class="profile container">
        <div v-if="profile" class="card">
            <h2 class="deep-purple-text center">{{ profile.alias }}'s wall</h2>
            <form @submit.prevent="addComment">
                    <p class="red-text center" v-if="feedback">{{ feedback }}</p>
                    <div class="field">
                        <label for="comment">Add a comment (press enter to add)</label>
                        <input type="text" name="comment" v-model="newComment">
                    </div>
            </form>
            <ul class="comments collection">
                <li class="deep-purple-text" v-for="(comment, index) in comments" :key="index">
                    <div class="deeple-purple-text">{{ comment.from }}</div>
                    <div class="grey-text text-darken-2">{{ comment.content }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase'
export default {
    name: 'profile',
    data() {
        return {
            profile: null,
            newComment: null,
            feedback: null,
            user: null,
            comments: []
        }
    },
    created() {
        let ref = db.collection('users')
        ref.where('user_id', '==', firebase.auth().currentUser.uid).get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                this.user = doc.data(),
                this.user.id = doc.id
            })
        })

        ref.doc(this.$route.params.id).get()
        .then(user => {
            this.profile = user.data()
        })

        //get comments data
        db.collection('comments').orderBy('time').where('to', '==', this.$route.params.id)
        .onSnapshot(snapshot => {
            snapshot.docChanges().forEach(change => {
                if (change.type == 'added') {
                    this.comments.unshift({
                        from: change.doc.data().from,
                        content: change.doc.data().content
                    })
                }
            })
        })

    },
    methods: {
        addComment() {
            if(this.newComment) {
                this.feedback = null
                db.collection('comments').add({
                    content: this.newComment,
                    time: Date.now(),
                    to: this.$route.params.id,
                    from: this.user.alias
                })
                .then(() => {
                    this.newComment = null
                })
            } else {
                this.feedback = "You must enter a comment!"
            }
        }
    }
}
</script>

<style>

    .profile h2 {
        margin-top: 0;
        font-size: 2em;
    }
    
    .profile .card {
        padding: 3%;
        margin-top: 6%;
    }

    .profile li {
        padding: 1%;
        border-bottom: 1px solid #eee
    }

    .profile input:focus {
        border-color: blueviolet !important;
    }

    @media screen and (max-width: 768px) {
        .profile .card {
            box-shadow: none;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/profile/profile.vue